import React from "react";
import Container from "../../../Components/Container";
import BG from "./assets/Background2@2x.png";
import BBB from "./assets/BBB@2x.png";
import styled from "styled-components";

const WhyMomentumStyles = styled.div`
  width: 100%;
  height: 100%;
  background-position: 37% -1%;
  background-size: 105% 110%;
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.2)
    ),
    url(${BG});

  display: grid;
  grid-template-rows: 150px 1fr 30px;

  img {
    width: 80%;
  }

  .grid-container {
    display: grid;
    align-items: center;
    justify-items: center;
    text-align: center;
    color: white;
    font-weight: 600;
    grid-template-rows: 260px repeat(2, min-content);
    grid-gap: 18px;
  }

  .bbb-header {
    font-size: 32px;
    text-transform: uppercase;
    font-weight: 400;
  }
  .bbb-copy {
    display: grid;
    grid-gap: 14px;
    font-size: 18px;
    font-family: lato;
  }
`;

const WhyMomentum = () => {
  return (
    <>
      <Container>
        <WhyMomentumStyles>
          <div className="false"></div>
          <div className="grid-container">
            <div className="div">
              <img alt="bbb" className="no-drag" src={BBB} />
            </div>
            <div className="bbb-header">
              A BBB Accredited Business Since 3/24/2015
            </div>
            <div className="bbb-copy">
              <span>
                BBB has determined that Momentum Solar meets BBB accreditation
                standards, which include a
              </span>
              <span>
                commitment to make a good faith effort to resolve any consumer
                complaints. BBB Accredited Businesses
              </span>
              <span>
                pay a fee for accreditation review/monitoring and for support of
                BBB services to the public.
              </span>
            </div>
          </div>
          <div className="false"></div>
        </WhyMomentumStyles>
      </Container>
    </>
  );
};

export default WhyMomentum;
